import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { BettingOddPartner } from '~/core/types';

type WithPartner = { $partner: BettingOddPartner };

export const OddsProviderContainer = styled.div<WithPartner>`
    ${BaseStyle.Mixins.fontStyles.ui['14m']}
    ${BaseStyle.Mixins.gaps.small}
    background: ${({ $partner }) => $partner.bgColor};
    border-radius: 100px;
    display: flex;
    align-items: center;
    margin-top: 8px;
    height: 40px;
    width: 100%;
    padding: 0 8px 0 16px;
    border: solid 1px ${({ $partner }) => $partner.accentColor};

    ${BaseStyle.Mixins.screenSizes.medium} {
        max-width: 345px;
        margin-top: 0;
    }
`;

export const NarrowOddsProviderContainer = styled(OddsProviderContainer)`
    border-radius: 0;
    width: calc(100% + 32px);
    position: relative;
    left: -16px;
    border: none;
    margin-top: 0;
    ${({ theme }) => BaseStyle.Mixins.utility.boxShadow(8, theme.Surface.shim, [BaseStyle.StyleDirections.down])}
`;

export const OddsProviderLabel = styled.div<WithPartner>`
    color: ${({ $partner }) => $partner.textColor};
    width: fit-content;
`;

export const BettingOddsLogoLink = styled.a<WithPartner>`
    ${BaseStyle.Mixins.gaps.small}
    display: flex;
    align-items: center;
    max-width: 115px;

    img {
        // make the svg as big as possible, while leaving room for the 'external link' icon and the gap between the logo
        // and that icon
        width: calc(100% - 14px - 8px);
        height: 34px;
    }

    svg {
        fill: ${({ $partner }) => $partner.textColor};
        ${BaseStyle.Mixins.fontStyles.ui['14m']}
    }
`;

export const BettingOddsToggle = styled.div`
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: end;
`;

export const BettingOddsSwitchLabel = styled.label<WithPartner>`
    color: ${({ $partner }) => $partner.textColor};
    text-align: right;
    text-transform: uppercase;
`;

export const BettingOddsClose = styled(BettingOddsToggle)<WithPartner>`
    svg {
        fill: ${({ $partner }) => $partner.textColor};
        ${BaseStyle.Mixins.fontStyles.ui['24m']}
    }

    :hover {
        cursor: pointer;
    }
`;

export const BettingOddsSwitch = styled.div<WithPartner & { $checked: boolean }>`
    .MuiSwitch-root {
        background: ${({ $checked, $partner, theme }) => ($checked ? $partner.bgColor : theme.Surface.primary)};
        border-radius: 100px;
        border: solid 2px ${({ $checked, $partner, theme }) => ($checked ? $partner.accentColor : theme.Surface.border)};
        height: 24px;
        width: 48px;
        margin-left: 8px;
    }

    .MuiButtonBase-root {
        height: 16px;
        top: 3px;
        left: 6px;
    }

    .MuiSwitch-track {
        background: none;
    }

    .MuiSwitch-thumb {
        background: ${({ $checked, $partner, theme }) => ($checked ? $partner.accentColor : theme.Surface.tertiary)};
        left: -12px;
        position: relative;
        box-shadow: none;
    }
`;

export const OddsProviderCard = styled.div<WithPartner>`
    border-radius: 8px;
    border: 2px solid ${({ $partner }) => $partner.bgColor};
    flex: 1;
    min-width: 100px;
    transition: background 400ms ease 0ms, border 400ms ease 0ms;
    min-height: 102px;
    padding: 16px 0 16px 12px;

    align-items: center;
    justify-content: center;
    flex-direction: column;
    background: ${({ $partner }) => $partner.bgColor};

    img {
        min-width: 76px;
    }

    ${BaseStyle.Mixins.screenSizes.medium} {
        min-width: 150px;
        padding: 16px 12px;
    }
`;
